import { motion } from 'motion/react';

interface WordmarkProps {
  size?: 'sm' | 'md' | 'lg';
}

/**
 * Wordmark do SmartApply — identidade tipográfica própria.
 *
 * Não é só "SmartApply" em sans default. É:
 * - Newsreader serif weight 500 com tracking apertado
 * - Marca-texto saffron sutil sob o "A" central (assinatura visual da marca)
 * - Bracket de marcação `[` à esquerda como ornamentação editorial
 *
 * Princípio de elevação E1 (docs/01 §6): a primeira impressão do produto é
 * o nome. Se o nome parece label de input, o resto vai parecer.
 */
export function Wordmark({ size = 'md' }: WordmarkProps) {
  const sizes = {
    sm: { text: 'text-base', bracket: 'text-base', mark: 'h-[3px]' },
    md: { text: 'text-2xl', bracket: 'text-2xl', mark: 'h-[5px]' },
    lg: { text: 'text-5xl', bracket: 'text-5xl', mark: 'h-[8px]' },
  };
  const s = sizes[size];

  return (
    <span className="inline-flex items-baseline" aria-label="SmartApply">
      <span
        className={`font-serif ${s.bracket} font-light text-[var(--accent-saffron)] tabular-nums`}
        aria-hidden
        style={{ marginRight: '0.15em' }}
      >
        [
      </span>
      <span
        className={`font-serif ${s.text} font-medium tracking-[-0.02em] text-[var(--ink-primary)]`}
      >
        Smart
        <span className="relative">
          A
          <motion.span
            aria-hidden
            className={`absolute inset-x-0 bottom-[0.08em] -z-0 ${s.mark} bg-[var(--accent-saffron-bg)]`}
            initial={{ scaleX: 0, originX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ delay: 0.2, duration: 0.4, ease: 'easeOut' }}
          />
        </span>
        pply
      </span>
    </span>
  );
}
